import type { FieldErrors } from "@/types/shared/form.types";
import { isAPIError, isFieldErrors } from '@/utils/type-guards';

// Re-export for backward compatibility
export { isAPIError, isFieldErrors };

export function extractFieldErrors(payload: unknown): FieldErrors {
  if (
    payload !== null &&
    typeof payload === 'object' &&
    'fieldErrors' in payload &&
    isFieldErrors(payload.fieldErrors)
  ) {
    return payload.fieldErrors;
  }
  return {};
}
